import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// mui does not support a default TabPanel out of the box except in experimental lab package so create one from examples
import TabPanel from '../../components/TabPanel/TabPanel';

import PageHeader from "../../components/PageHeader/PageHeader";
import ConnectorSchedulesTabPanel from './ConnectorSchedulesTabPanel';
import ConnectorConfigsTabPanel from './ConnectorConfigsTabPanel';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import { hasPermission, platformManage } from '../../Utils/Common';
import { usePermissionContext } from "../../contexts/permission-context";

const Connectors = () => {
    const { permissions } = usePermissionContext();
    const [createConnectorSchedule, setCreateConnectorSchedule] = useState(false);
    const [createConnectorConfig, setCreateConnectorConfig] = useState(false);

    const initialSnackbarState = {
        open: false,
        message: '',
        alertTitle: '',
        severity: 'info',
        hideDuration: 1000
    };

    const [notify, setNotify] = useState(
        initialSnackbarState
    );

    const hasPlatformManage = hasPermission(permissions, platformManage);

    // define names of tabs
    const tabs = [
        {
            label: 'Connector Schedules',
            value: 'connectorSchedules',
            component: <ConnectorSchedulesTabPanel setNotify={setNotify} createConnectorSchedule={createConnectorSchedule} setOpenConnectorSchedule={setCreateConnectorSchedule} />
        },
        {
            label: 'Connector Configs',
            value: 'connectorConfigs',
            component: <ConnectorConfigsTabPanel setNotify={setNotify} openConnectorConfig={createConnectorConfig} setOpenConnectorConfig={setCreateConnectorConfig} />
        },

    ];

    let selectedIndex = sessionStorage.getItem("connector") !== null ? sessionStorage.getItem("connector") : 0
    const [value, setValue] = useState(+selectedIndex);    // set to previous visited connector schedule tab
    const [selectedTab, setSelectedTab] = useState(tabs[value].value);

    const handleChange = (event, newValue) => {
        sessionStorage.setItem("connector", newValue)
        setSelectedTab(tabs[newValue].value);

        setValue(newValue);

        getPageHeader();       // needed??
    };


    // initially we needed different page headers. Requirement was changed. Technically we don't need this but leaving for now
    const getPageHeader = () => {

        switch (selectedTab) {
            // common page header on all tabs
            case 'connectorSchedules':
                return (<PageHeader title='Connectors' includeCreate={hasPlatformManage} createTitle='Create Schedule' onCreate={onCreateConnectorSchedule} />);  // if need create button
            case 'connectorConfigs':
                return (<PageHeader title='Connectors' includeCreate={hasPlatformManage} createTitle='Create Config' onCreate={onCreateConnectorConfig} />);  // if need create button
            default:
                return (<PageHeader title='Connectors' includeCreate={false} />);
        }
    };

    const onCreateConnectorSchedule = () => {
        // console.log("Create schedule button clicked");

        setCreateConnectorSchedule(true);
    };

    const onCreateConnectorConfig = () => {
        // console.log("Create connector config clicked");

        setCreateConnectorConfig(true);

    };

    return (
        <>

            <AlertSnackbar
                notify={notify}
                setNotify={setNotify} />

            {getPageHeader()}

            <Tabs value={value} onChange={handleChange} aria-label="connector tabs">
                {tabs.map((tab) => <Tab key={`${tab.value}-tab`} id={`${tab.value}-tab`} label={tab.label} sx={{ textTransform: 'none' }} />)}
            </Tabs>

            {tabs.map((tab, index) => <TabPanel key={`${tab.value}-panel`} id={`${tab.value}-panel`} value={value} index={index}>{tab.component}</TabPanel>)}

        </>
    );
}

export default Connectors;
